import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import styles from '../../containers/StewardAssetDisplayPage/StewardAssetDisplayPage.scss';

const propTypes = {
  label: PropTypes.string,
  field: PropTypes.string,
  arrayIdField: PropTypes.string,
  arrayFields: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.bool
  ]),
  fullWidth: PropTypes.bool
};

const defaultProps = {
  value: ''
};

export default function TextDisplay(props) {
  const id = `mod_${props.field.replace('.', '_')}`;
  const label = !props.label ? null : (
    <label htmlFor={id}>{props.label}</label>
  );
  const boolValue = props.value ? "Yes" : "No";
  const css = `${styles["text-display"]} ${props.fullWidth ? styles["full-width"] : ""}`;
  return (
    <div className={css}>
      {label}
      {props.arrayFields && props.arrayIdField && Array.isArray(props.value) ?
        props.value.map((value) => (
          <div key={get(value, props.arrayIdField)} className={styles["array-display"]} >
            {props.arrayFields.map((field) => (
              <p key={field} >
                {get(value, field)}
              </p>
            ))}
          </div>
        ))
        :
        <p>{typeof(props.value) === "boolean"? boolValue : props.value}</p>
      }
    </div>
  );
}

TextDisplay.propTypes = propTypes;
TextDisplay.defaultProps = defaultProps;
